const DIRECT_CALL_RULES = {
  TRACK_ACTION: 'trackAction',
  TRACK_PAGE: 'trackPage',
} as const;

export default DIRECT_CALL_RULES;
